<div class="frame-1-2" *ngIf="number">
    <p class="text-1">{{number}}</p>
    <p class="name" *ngIf="name">{{name}}</p>
    <p class="name" *ngIf="!name">Sin nombre</p>
  </div>